<div class="row">
  <div class="col-md-12">
    <div class="d-flex">
      <myp-segmented-bar [white]="true" (selected)="selectSection($event.id)" [options]="sections"></myp-segmented-bar>
      <button class="fa-button m-l-10" placement="bottom" [ngbTooltip]="'Add New Product'" (click)="create()">
        <fa-icon icon="plus" class="action create-action circle-icon-btn"></fa-icon>
      </button>
    </div>

    <myp-inline-loader [loading]="loading" height="400px" spinnerName="loading"></myp-inline-loader>
    @if (!loading && products && products.length) {
      <div class="m-t-20">
        <myp-product-filter (filterChanged)="filterProducts($event)" (sortChanged)="sortProducts()" [showSortType]="false" [showListGrid]="false"></myp-product-filter>
        @for (product of displayedProducts; track product) {
          <div class="m-b-10 m-t-10">
            <myp-list-item
              (itemClicked)="go(product.id)"
              [metadata]="product.displayMetadata"
              [href]="'/products/detail/' + product.id"
              [photo]="product.imageUrl ? product.imageUrl : ''"
              [showImage]="product.imageUrl"
              [title]="product.title"
              [imageRound]="false"
            >
              @if (!product.metadata?.categories?.length) {
                <div class="button-content">
                  <button
                    type="button"
                    class="circle-icon-btn m-r-10 bg-transparent border-0 p-0"
                    placement="left"
                    [ngbTooltip]="'Categorize This Product'"
                    (click)="showModal(addCategoryModal, product, $event)"
                  >
                    <fa-icon icon="layer-group" class="action" aria-hidden="true"></fa-icon>
                    <span class="sr-only">Categorize Product</span>
                  </button>
                </div>
              }
            </myp-list-item>
            <hr class="m-y-5" />
          </div>
        }
        @if (!filtering) {
          <myp-paginator
            [offset]="pageOffset + 1"
            [limit]="pageLimit"
            [resultsLength]="displayedProducts.length"
            [totalPages]="totalPages"
            [totalResults]="products.length"
            [paginate]="paginate"
            [async]="false"
          ></myp-paginator>
        }
      </div>
    }
  </div>
</div>

<ng-template #addCategoryModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-password-update">Add Category for {{ categorizingProduct.title }}</h4>
    <button ngbAutofocus class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @for (cat of productService.productCategories; track cat) {
      <div class="product-category">
        <button class="category-name small-btn" (click)="selectCategory(cat.string_id)">
          {{ cat.title }}
        </button>
        <div class="subcategories">
          @for (subcat of cat.children; track subcat) {
            <div class="product-subcategory">
              <button class="subcategory-name small-btn" (click)="selectCategory(subcat.string_id)">
                {{ subcat.title }}
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>
